/**
 * 公共JS类
 */
var s = s || {}
import Vue from 'vue' //vue核心库
import configParams from './config' //配置文件库

// //全局的静态属性  s.v.'key'
s.v = configParams;

/*******************************************************************************【提示】 toast，loading  *********************************************************************************/
s.text = function(tips,time,icon) {
	if (!tips) {
		tips = '成功';
	}
	uni.showToast({
		title: tips,
		icon:icon||'none',
		duration: time ? time : 2000 //提示的延迟时间(默认2000毫秒)
	});
}
s.success = function(tips,time) {
	if (!tips) {
		tips = '成功';
	}
	uni.showToast({
		title: tips,
		icon:'success',
		duration: time ? time : 2000 //提示的延迟时间(默认2000毫秒)
	});
}
/*提醒*/
s.message = function(tips,time) {
	if (!tips) {
		tips = '提醒';
	}
	uni.showToast({
		title: tips,
		icon:'message',
		duration: time ? time : 2000 //提示的延迟时间(默认2000毫秒)
	});
}
/**
 * 加载 提示
 * @param {提示} tips 
 */
s.loading = function(tips, time) {
	if (!tips) {
		tips = 'base.tips.loading';
	}
	uni.showToast({
		title: tips,
		image: s.icon.loading,
		duration: 2000
	});
}

/**
 * 关闭toast 
 */
s.closeToast = function() {
	uni.hideToast();

}
//关闭 loading
s.closeLoadingt = function() {
	uni.hideLoading();
}

// /********************************************************************************【弹框】  confirm   ********************************************************************************/
/**
 * 
 * @param {标题} title 
 * @param {内容} content 
 * @param {显示事件} onShow 
 * @param {关闭事件} onHide 
 */
s.confirm = function(title, content, onShow, onHide) {
	uni.showModal({
		title: title,
		content: content,
		showCancel: true,
		confirmText: '确认',
		cancelText: '取消',
		success: function(res) {
			if (res.confirm) {
				if (onShow) {
					onShow();
				}
			} else if (res.cancel) {
				if (onHide) {
					onHide()
				}
			}
		},


	});

}


/**根据经纬度计算距离
纬度1,经度1,纬度2,经度2
*/
s.GetDistance = function GetDistance(lat1, lng1, lat2, lng2) {
	var radLat1 = lat1 * Math.PI / 180.0;
	var radLat2 = lat2 * Math.PI / 180.0;
	var a = radLat1 - radLat2;
	var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
	var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
		Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
	s = s * 6378.137; // EARTH_RADIUS;
	s = Math.round(s * 10000) / 10000;
	return s;
}




/********************************************************************** 缓存********************************************************************* */

/**
 * 取值
 * @param {} key 
 */
s.getVal = function(key) {





	return uni.getStorageSync(key)
}
//适配app和小程序的回去存储方式
s.getValue = function(val) {
	let result
	// uni.webView.getEnv(function(res) {
	// 	if (res.plus) {
	// 		result = plus.storage.getItem(val);
	// 		// if (val != 'access_token' && val != 'refresh_token') {
	// 		// 	result = JSON.parse(result).data
	// 		// }
	// 	} else {
			result = uni.getStorageSync(val)
		// }
	// });
	return result
},
s.setValue = function(key,value) {
	// uni.webView.getEnv(function(res) {
	// 	if (res.plus) {
	// 		plus.storage.setItem(key,value);
	// 	} else {
			uni.setStorageSync(key,value)
		// }
	// });
},
/**
 * 存值
 * @param {key} key 
 * @param {值} value 
 */
s.setVal = function(key, value) {






	uni.setStorageSync(key, value);
}
/**
 * 同步清理指定本地数据缓存
 * @param {} key 
 */
s.removeVal = function(key) {



	uni.removeStorageSync(key)
}



/**
 * 同步清理本地数据缓存
 * @param {} key 
 */
s.clearVal = function() {



	//将是否第一次进入设置为否
	uni.clearStorage();
	// s.setVal(s.v.isFirst,"no")
}

// /******************************************************************路由跳转************************************************************************* */

/**
 * 原生路由跳转,需要跳转的应用内页面路径 , 路径后可以带参数。参数与路径之间使用?分隔，参数键与参数值用=相连，不同参数用&分隔；如 'path?key=value&key2=value2'，如果跳转的页面路径是 tabBar 页面则不能带参数
 */
s.go = function(params) {
	uni.navigateTo({
		url: params
	})
}
s.redict = function(params) {
	uni.redirectTo({
		url: params
	})
}
/********************************************************************list转换 树形结构****************************************************************************/

/** 
 * json格式转标准树状结构 
 * @param {json} json数据 $.parseJSON()  list数据 [{},{}]
 * @param {String} id的字符串 属性名称  根据这个找到主键  一般是 id
 * @param {String} 父id的字符串 属性名称  根据这个找到叶子节点   一般是 parentId
 * @param {String} children的字符串 属性名称  例如：children
 * @param {open} 是否展开  1展开
 * @return {Array} 树形数组 
 */
s.parseTree = function(json, idStr, pidStr, childrenStr, open, point, name) {
	/****默认值：结合后端树形表结构 id,parentId,parentIds 同时结合前端iview children   组装为树形结构****/
	if (!idStr) {
		idStr = "id"
	}
	if (!pidStr) {
		pidStr = "parentId"
	}
	if (!childrenStr) {
		childrenStr = "children"
	}
	if (!point) {
		point = ""
	}

	var r = [],
		hash = {},
		id = idStr,
		pid = pidStr,
		children = childrenStr,
		i = 0,
		j = 0,
		len = json.length;
	for (; i < len; i++) {
		json[i][children] = []
		hash[json[i][id]] = json[i];
	}

	for (; j < len; j++) {
		var aVal = json[j],
			hashVP = hash[aVal[pid]];

		if (!name) {
			aVal['name'] = aVal['name'] + point; //name 放入title  iviewTree使用
		} else {

			aVal['name'] = aVal['name'] + point + aVal[name]; //name 放入title  iviewTree使用
			if (aVal['isLeaf'] && aVal['isLeaf'] == '1') { //最后一级
				var allTitle = '' //所有称
				for (var l = 0; l < len; l++) {
					var aleafVal = json[l]
					if (aVal['parentIds'].indexOf(aleafVal['id']) != -1) { //包含
						allTitle = allTitle + aleafVal['name'] + point
					}
				}
				aVal['allTitle'] = allTitle

			}
		}
		if (hashVP) {
			!hashVP[children] && (hashVP[children] = []);
			hashVP[children].push(aVal);
		} else {
			r.push(aVal);
		}
	}
	return r;
}
/*********************************************************************list转换 树形结构****************************************************************************/

/**
 * MD5
 */
var MD5 = require('md5.js')
s.password = function(pwd, date) {
	return new MD5().update(pwd + date).digest('hex')
}

/**
 * 返回uuid
 */
s.uuid = function() {
	function S4() {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	}
	return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

/*****************************************************************相对时间显示************************************************************************** */
s.date = function(time) {
	let oldDate = new Date(time)
	let newDate = new Date()
	var dayNum = "";
	var getTime = (newDate.getTime() - oldDate.getTime()) / 1000;
	if (getTime < 60) {
		dayNum = s.t('base.date.justNow'); // just now
	} else if (getTime >= 60 * 1 && getTime < 60 * 60) {
		dayNum = parseInt(getTime / 60) + s.t('base.date.minutesAgo'); //minutes ago
	} else if (getTime >= 3600 && getTime < 3600 * 24) {
		dayNum = parseInt(getTime / 3600) + s.t('base.date.hoursAgo'); // hours ago
	} else if (getTime >= 3600 * 24 && getTime < 3600 * 24 * 30) {
		dayNum = parseInt(getTime / 3600 / 24) + s.t('base.date.dayAgo'); // day ago
	} else if (getTime >= 3600 * 24 * 30 && getTime < 3600 * 24 * 30 * 12) {
		dayNum = parseInt(getTime / 3600 / 24 / 30) + s.t('base.date.monthAgo'); // month ago
	} else if (time >= 3600 * 24 * 30 * 12) {
		dayNum = parseInt(getTime / 3600 / 24 / 30 / 12) + s.t('base.date.yearsAgo'); //years ago
	}
	return dayNum;
}

s.formateDate = function(datetime, type) {
	var year = datetime.getFullYear(),
		month = ("0" + (datetime.getMonth() + 1)).slice(-2),
		date = ("0" + datetime.getDate()).slice(-2),
		hour = ("0" + datetime.getHours()).slice(-2),
		minute = ("0" + datetime.getMinutes()).slice(-2),
		second = ("0" + datetime.getSeconds()).slice(-2);
	if (type === "Y-M-D h:min:s") {
		var result = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
	} else if (type === "Y-M-D") {
		var result = year + "-" + month + "-" + date;
	}
	if (type === "h:min:s") {
		var result = hour + ":" + minute + ":" + second;
	}
	return result;
}
/***********************************************传入时间戳，转换为yyyy-mm-dd**********************************/
s.fmtDate = function(obj) {
	var date = new Date(obj);
	var y = 1900 + date.getYear();
	var m = "0" + (date.getMonth() + 1);
	var d = "0" + date.getDate();
	return y + "-" + m.substring(m.length - 2, m.length) + "-" + d.substring(d.length - 2, d.length);
}
s.fmtTime=function(timestamp) {
  const dateObj = new Date(timestamp);
  const year = dateObj.getFullYear();
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();
  const seconds = dateObj.getSeconds();
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
}

s.getNowDate = function getNowDate() {
	var date = new Date();
	var sign1 = "-";
	var sign2 = ":";
	var year = date.getFullYear() // 年
	var month = date.getMonth() + 1; // 月
	var day = date.getDate(); // 日
	var hour = date.getHours(); // 时
	var minutes = date.getMinutes(); // 分
	var seconds = date.getSeconds() //秒
	//	 var weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'];
	//	 var week = weekArr[date.getDay()];
	// 给一位数数据前面加 “0”
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (day >= 0 && day <= 9) {
		day = "0" + day;
	}
	if (hour >= 0 && hour <= 9) {
		hour = "0" + hour;
	}
	if (minutes >= 0 && minutes <= 9) {
		minutes = "0" + minutes;
	}
	if (seconds >= 0 && seconds <= 9) {
		seconds = "0" + seconds;
	}
	var currentdate = year + sign1 + month + sign1 + day + " " + hour + sign2 + minutes + sign2 + seconds;
	return currentdate;
}
//得到两个日期相差的分钟数
s.timeDifferenceMinute = function(beginTime, endTime) {
	//截取字符串，得到日期部分"2009-12-02",用split把字符串分隔成数组
	var begin1 = beginTime.substr(0, 10).split("-");
	var end1 = endTime.substr(0, 10).split("-");
	//将拆分的数组重新组合，并实例成化新的日期对象
	var date1 = new Date(begin1[1] + - +begin1[2] + - +begin1[0]);
	var date2 = new Date(end1[1] + - +end1[2] + - +end1[0]);
	//得到两个日期之间的差值m，以分钟为单位
	//Math.abs(date2-date1)计算出以毫秒为单位的差值
	//Math.abs(date2-date1)/1000得到以秒为单位的差值
	//Math.abs(date2-date1)/1000/60得到以分钟为单位的差值
	var m = parseInt(Math.abs(date2 - date1) / 1000 / 60);
	//小时数和分钟数相加得到总的分钟数
	//time1.substr(11,2)截取字符串得到时间的小时数
	//parseInt(time1.substr(11,2))*60把小时数转化成为分钟
	var min1 = parseInt(beginTime.substr(11, 2)) * 60 + parseInt(beginTime.substr(14, 2));
	var min2 = parseInt(endTime.substr(11, 2)) * 60 + parseInt(endTime.substr(14, 2));
	//两个分钟数相减得到时间部分的差值，以分钟为单位
	var n = min2 - min1;
	//将日期和时间两个部分计算出来的差值相加，即得到两个时间相减后的分钟数
	var minutes = m + n;
	return minutes;
}
//得到两个日期相差的天数
s.timeDifferenceDay = function(startDate, endDate) {
	var dateSpan,
		tempDate,
		iDays;
	startDate = Date.parse(startDate);
	endDate = Date.parse(endDate);
	dateSpan = endDate - startDate;
	dateSpan = Math.abs(dateSpan);
	iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
	return iDays
};
/**
 * 字节转为M
 */
s.bytesOnM = function(bytes) {
	if (bytes === 0) return '0';
	let k = 1024,
		sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
		i = Math.floor(Math.log(bytes) / Math.log(k));
	return (bytes / Math.pow(k, 2)).toFixed(2);
}
/**
 * kb转为M
 */
s.KbOnM = function(kb) {
	if (kb === 0) return '0';
	let k = 1024,
		i = eval(kb / k).toFixed(2)
	return i;
}

/**
 * 定义一个map
 * 如：var map=new s.HashMap();
 * */
s.HashMap = function() {
	//定义长度
	var length = 0;
	//创建一个对象
	var obj = new Object();

	/**
	 * 判断Map是否为空
	 */
	this.isEmpty = function() {
		return length == 0;
	};

	/**
	 * 判断对象中是否包含给定Key
	 */
	this.containsKey = function(key) {
		return (key in obj);
	};

	/**
	 * 判断对象中是否包含给定的Value
	 */
	this.containsValue = function(value) {
		for (var key in obj) {
			if (obj[key] == value) {
				return true;
			}
		}
		return false;
	};

	/**
	 *向map中添加数据
	 */
	this.put = function(key, value) {
		if (!this.containsKey(key)) {
			length++;
		}
		obj[key] = value;
	};

	/**
	 *向map原数据 添加数据
	 */
	this.putAll = function(key, value) {
		if (!this.containsKey(key)) {
			length++;
		}
		if (this.get(key)) {
			obj[key] = this.get(key) + ',' + value;
		} else {
			obj[key] = value;
		}
	};

	/**
	 * 根据给定的Key获得Value
	 */
	this.get = function(key) {
		return this.containsKey(key) ? obj[key] : null;
	};

	/**
	 * 根据给定的Key删除一个值
	 */
	this.remove = function(key) {
		if (this.containsKey(key) && (delete obj[key])) {
			length--;
		}
	};

	/**
	 * 获得Map中的所有Value
	 */
	this.values = function() {
		var _values = new Array();
		for (var key in obj) {
			_values.push(obj[key]);
		}
		return _values;
	};

	/**
	 * 获得Map中的所有Key
	 */
	this.keySet = function() {
		var _keys = new Array();
		for (var key in obj) {
			_keys.push(key);
		}
		return _keys;
	};

	/**
	 * 获得Map的长度
	 */
	this.size = function() {
		return length;
	};

	/**
	 * 清空Map
	 */
	this.clear = function() {
		length = 0;
		obj = new Object();
	};
};


export default s
